import SvgMaintenance from "@/assets/illustrations/maintenance.svg";
import { MdSettings } from "react-icons/md";

export default function SystemMaintenancePage() {
  return (
    <main className="h-screen flex flex-col justify-center items-center bg-gray-100 text-center">
      <img
        src={SvgMaintenance}
        alt="maintenance"
        width={400}
        className="mb-8"
      />
      <div className="flex gap-3 items-center">
        <MdSettings size={25} className="animate-spin" />
        <h1 className="text-2xl font-bold text-gray-800">
          We’re Polishing Things Up!
        </h1>
      </div>
      <p className="text-gray-600 mt-4">
        Our system is temporarily undergoing maintenance to serve you better.{" "}
        <br />
        We’ll be back shortly with an even smoother experience!
      </p>
      <p className="text-gray-500 text-sm mt-6">
        Thank you for your patience and understanding. Stay tuned!
      </p>
    </main>
  );
}
